import { z } from 'zod';
/** RFC 9457 problem details; every API error uses this shape. */
export const ProblemDetails = z.object({
    type: z.string().default('about:blank'),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    instance: z.string().optional(),
    errors: z
        .array(z.object({
        field: z.string().optional(),
        code: z.string(),
        message: z.string(),
    }))
        .optional(),
});
export const HealthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    service: z.string(),
    version: z.string(),
    checks: z.record(z.enum(['ok', 'fail'])),
});
//# sourceMappingURL=common.js.map